import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface SkeletonProviderProps {
  children: React.ReactNode;
}

export const SkeletonProvider = ({ children }: SkeletonProviderProps) => {
  return (
    <SkeletonTheme
      baseColor="#07080c66"
      highlightColor="var(--primary)"
      borderRadius={8}
      duration={1.5}
    >
      {children}
    </SkeletonTheme>
  );
};
